module.exports = __webpack_public_path__ + "img/58_3.20087758.png";